module.exports = __webpack_public_path__ + "443892cf759281751793e80ce20a3575.svg";